export default {
      id: "author-comments-yellow-usage",
      viewBox: "0 0 20 20",
      url: "/" + "images/icons.3.109.2.svg#author-comments-yellow-usage",
      toString: function () {
        return this.url;
      }
    }